import {IntermediatePart} from "../../intermediatePart";

export default class Hook extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'hook';
    this.partName = 'Hook';
    this.translateId = "visualizer.laundryRoom.hook";
    this.canBeDisabled = true;
  }

}
